import $apiPublic from 'api/apiPublic'
import $apiPrivate from 'api/apiPrivate'

const signup = async (credentials) => {
  const response = await $apiPublic
    .post('/user/auth/create', credentials)
  return response
}

const checkSignupOtp = async (data) => {
  const response = await $apiPublic
    .post('/user/auth/verify-email', data)
  return response
}

const login = async (credentials) => {
  const response = await $apiPublic
    .post('/user/auth/login', credentials)
  return response
}

const logout = async () => {
  const response = await $apiPrivate
    .post('/user/auth/logout')
  return response
}

const forgotPassword = async (email) => {
  const response = await $apiPublic
    .post('/user/auth/forgot-password-code', { email })
  return response
}

const checkForgotOtp = async (credentials) => {
  const response = await $apiPublic
    .post('/user/auth/check-forgot-otp', credentials)
  return response
}

const passwordReset = async (credentials) => {
  const response = await $apiPublic
    .post('/user/auth/reset-password-with-code', credentials)
  return response
}

const refreshToken = async () => {
  const response = await $apiPublic
    .post('/user/auth/refresh-token')
  return response
}

export default {
  signup,
  checkSignupOtp,
  login,
  logout,
  forgotPassword,
  checkForgotOtp,
  passwordReset,
  refreshToken,
}